import { styled } from "styled-components";
import { BlueBirdTheme } from "@kitbird/core";

export const WrapperUpload = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 12px;
  border: 1px #dedede solid;
  border-radius: 8px;
`;
export const WrapperInput = styled.div`
  width: 278px;
`;
export const UploadSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;
export const WrapperLabel = styled.div`
  width: 184px;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;
export const WrapperIcon = styled.div`
  align-self:start;
`;

export const WrapperContainerForm = styled.div<{ $drag?: boolean }>`
  padding: 18px;
  border-radius: 5px;
  border: ${(p) => (p.$drag ? "dashed 2px #444444" : "solid 1px #dedede")}; 
  display: flex;
  background-color: ${(p) => (p.$drag ? "#f0f0f0" : "#F2F6FB")};
  position: relative;
`;

export const WrapperIconDesc = styled.div`
  display: flex;
  gap: 14px;
  position: relative;
  z-index: 1;
  flex-grow: 1;
  pointer-events: none;
`;
export const WrapperInputHidden = styled.input`
  padding: 3px;
`;
export const WrapperDrag = styled.div`
  padding: 0;
  margin: 0;
`;
